var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-props-no-spreading */
/* disable for HTMLLabelElement props passthrough to generic label */
import React from 'react';
import styled, { css } from 'styled-components';
import formTheme from '../theme';
import { ComponentThemeProvider, renderFont } from '../../ThemeProvider';
/**
 * Returns the style for the inline prop
 */
var inlineVariant = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline;\n  font-weight: 400;\n  text-transform: none;\n\n  input {\n    position: relative;\n    margin-right: ", ";\n    vertical-align: text-top;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  display: inline;\n  font-weight: 400;\n  text-transform: none;\n\n  input {\n    position: relative;\n    margin-right: ", ";\n    vertical-align: text-top;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.label.margin;
});
var getLabelColor = function (theme, disabled, inline) {
    if (disabled === void 0) { disabled = false; }
    if (inline === void 0) { inline = false; }
    if (disabled && inline) {
        return theme.component.form.label.disabledInline.color;
    }
    if (disabled) {
        return theme.component.form.textColor.disabled;
    }
    return theme.component.form.textColor.normal;
};
var StyledLabel = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  padding-bottom: ", ";\n  color: ", ";\n  ", "\n  font-size: ", ";\n  text-align: left;\n\n  ", ";\n"], ["\n  display: block;\n  padding-bottom: ",
    ";\n  color: ", ";\n  ", "\n  font-size: ", ";\n  text-align: left;\n\n  ", ";\n"])), function (_a) {
    var component = _a.theme.component, inline = _a.inline;
    return inline ? '0' : component.form.label.padding;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled, inline = _a.inline;
    return getLabelColor(theme, disabled, inline);
}, function (_a) {
    var theme = _a.theme;
    return renderFont('base', 'normal', theme);
}, function (_a) {
    var component = _a.theme.component;
    return component.form.fontSize.small;
}, function (props) { return props.inline && inlineVariant; });
export var Label = function (props) { return (React.createElement(ComponentThemeProvider, { theme: formTheme },
    React.createElement(StyledLabel, __assign({}, props)))); };
export default Label;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map